/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Copy_CopiedInputs */

const es_chat_copy_copied = /** @type {(inputs: Chat_Copy_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado`)
};

const en_chat_copy_copied = /** @type {(inputs: Chat_Copy_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Chat_Copy_CopiedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_copy_copied = /** @type {((inputs?: Chat_Copy_CopiedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Copy_CopiedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_copy_copied(inputs)
	return en_chat_copy_copied(inputs)
});
export { chat_copy_copied as "chat.copy.copied" }